// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartCharging {
  padding-inline: 20px;
  position: relative;
  height: 100vh;
  background-color: #f8f8f8;
}
.StartCharging--Polling {
  width: 100%;
  display: grid;
  place-items: center;
  font-size: 1.6rem;
}
.StartCharging--Container {
  padding: 4rem 3rem;
  height: auto;
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background: #e6f7ef;
}
.StartCharging--ImgContainer {
  justify-content: center;
  align-items: center;
  gap: 20px;
  display: flex;
  position: relative;
  flex-direction: column;
}
.StartCharging--ProgressBar {
  display: block;
  flex-direction: column;
}
.StartCharging--BatteryImg {
  width: 224.292px;
  height: 224.292px;
  position: absolute;
  transform: translate(-50%, -50%);
  transform: rotate(-49.269deg);
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.16;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.08;
  }
  100% {
    transform: scale(1);
    opacity: 0.16;
  }
}
.StartCharging--OuterCircle {
  width: 222.171px;
  height: 222.171px;
  background: #00aa74;
  border-radius: 288px;
  opacity: 0.08;
  animation: pulse 2s infinite;
}
.StartCharging--InnerCircle {
  position: absolute;
  right: 0;
  width: 288px;
  height: 288px;
  background: #00aa74;
  border-radius: 288px;
  opacity: 0.1;
}

.StartCharging--Select {
  display: flex;
  gap: 2rem;
  padding-block: 24px;
  font-weight: 600;
}
.StartCharging--Select p {
  font-size: 18px;
  align-self: center;
}

.charging-progress {
  display: flex;
  justify-content: center;
}

.StartCharging--card {
  display: flex;
}
.StartCharging--card div {
  display: flex;
  justify-content: space-between;
  flex: 1;
  max-width: 100dvw;
  column-gap: 2rem;
}

.StartCharging--btn {
  position: absolute;
  bottom: 2rem;
  width: 90%;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/StartChargeingView/StartCharging/startcharging.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAGA;EACI,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AAFJ;AAII;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAFR;AAII;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBCMU;ADRlB;AAII;EACI,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AAFR;AAII;EACI,cAAA;EACA,sBAAA;AAFR;AAII;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,6BAAA;AAFR;AAII;EACI;IACI,mBAAA;IACA,aAAA;EAFV;EAIM;IACI,qBAAA;IACA,aAAA;EAFV;EAIM;IACI,mBAAA;IACA,aAAA;EAFV;AACF;AAKI;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,4BAAA;AAHR;AAMI;EACI,kBAAA;EACA,QAAA;EACA,YAnEa;EAoEb,aApEa;EAqEb,mBAAA;EACA,oBAtEa;EAuEb,YAAA;AAJR;;AAOA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAKI;EACI,eAAA;EACA,kBAAA;AAHR;;AAMA;EACI,aAAA;EACA,uBAAA;AAHJ;;AAKA;EACI,aAAA;AAFJ;AAGI;EACI,aAAA;EACA,8BAAA;EACA,OAAA;EACA,iBAAA;EACA,gBAAA;AADR;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AADJ","sourcesContent":["@import '../../../../Styles/sass/variables';\n$img-container-size: 288px;\n\n.StartCharging {\n    padding-inline: 20px;\n    position: relative;\n    height: 100vh;\n    background-color: #f8f8f8;\n\n    &--Polling {\n        width: 100%;\n        display: grid;\n        place-items: center;\n        font-size: 1.6rem;\n    }\n    &--Container {\n        padding: 4rem 3rem;\n        height: auto;\n        border-radius: 20px;\n        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n        background: $color_green_100;\n    }\n    &--ImgContainer {\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        display: flex;\n        position: relative;\n        flex-direction: column;\n    }\n    &--ProgressBar {\n        display: block;\n        flex-direction: column;\n    }\n    &--BatteryImg {\n        width: 224.292px;\n        height: 224.292px;\n        position: absolute;\n        transform: translate(-50%, -50%);\n        transform: rotate(-49.269deg);\n    }\n    @keyframes pulse {\n        0% {\n            transform: scale(1);\n            opacity: 0.16;\n        }\n        50% {\n            transform: scale(1.1);\n            opacity: 0.08;\n        }\n        100% {\n            transform: scale(1);\n            opacity: 0.16;\n        }\n    }\n\n    &--OuterCircle {\n        width: 222.171px;\n        height: 222.171px;\n        background: #00aa74;\n        border-radius: 288px;\n        opacity: 0.08;\n        animation: pulse 2s infinite;\n    }\n\n    &--InnerCircle {\n        position: absolute;\n        right: 0;\n        width: $img-container-size;\n        height: $img-container-size;\n        background: #00aa74;\n        border-radius: $img-container-size;\n        opacity: 0.1;\n    }\n}\n.StartCharging--Select {\n    display: flex;\n    gap: 2rem;\n    padding-block: 24px;\n    font-weight: 600;\n    p {\n        font-size: 18px;\n        align-self: center;\n    }\n}\n.charging-progress {\n    display: flex;\n    justify-content: center;\n}\n.StartCharging--card {\n    display: flex;\n    div {\n        display: flex;\n        justify-content: space-between;\n        flex: 1;\n        max-width: 100dvw;\n        column-gap: 2rem;\n    }\n}\n.StartCharging--btn {\n    position: absolute;\n    bottom: 2rem;\n    width: 90%;\n    margin: auto;\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
